import { render } from "./form1.vue?vue&type=template&id=5b32c3ee"
import script from "./form1.vue?vue&type=script&lang=js"
export * from "./form1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__